import '../../style/index.less';
import './index.less';
import "../../style/nsky/reset/checkbox/index.less";



/** WEBPACK FOOTER **
 ** ./components/checkbox/style/index.js
 **/